/* eslint-disable*/

import React from 'react';
import { useEffect } from 'react';
// kakao 기능 동작을 위해 넣어준다.
const { Kakao } = window;

export default () => {
  // 배포한 자신의 사이트
  const realUrl = `https://${process.env.REACT_APP_ENV ?? 'develop'}.d3s2wjwpjlsdpk.amplifyapp.com/survey-v1`;

  // 재랜더링시에 실행되게 해준다.
  useEffect(() => {
    // init 해주기 전에 clean up 을 해준다.
    Kakao.cleanup();
    // 자신의 js 키를 넣어준다.
    Kakao.init('a44e11a0a28219041f58922e175b6e4a');
    // 잘 적용되면 true 를 뱉는다.
    console.log(Kakao.isInitialized());
  }, []);

  const shareKakao = () => {
    Kakao.Share.sendDefault({
      objectType: 'feed',
      content: {
        title: '한의진단 MBTI',
        description: '#내 몸의 상태는? #내게 맞는 약재 찾기',
        imageUrl: `https://yejin-img.s3.ap-northeast-2.amazonaws.com/b2c-for-kakao.png`,
        link: {
          mobileWebUrl: realUrl,
        },
      },
      buttons: [
        {
          title: '테스트 하러가기',
          link: {
            mobileWebUrl: realUrl,
          },
        },
      ],
    });
  };

  return (
    <button
      type="button"
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        background: '#FFFFFF',
        width: 'calc(100% - 32px)',
        height: '52px',
        borderRadius: '20px',
        border: 'none',
        color: '#1D1C1D',
        fontSize: '20px',
        fontWeight: 700,
        letterSpacing: '0.1px',
        columnGap: '10px',
      }}
      onClick={() => {
        shareKakao();
      }}
    >
      <img
        src={`${process.env.PUBLIC_URL}/img/kakao-talk-img.png`}
        alt="kakao-icon"
        style={{
          width: '24px',
          height: '24px',
          flexShrink: 0,
        }}
      />
      카카오톡 공유하기
    </button>
  );
};
